import { Component, OnInit, OnDestroy, Input, AfterViewInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Subject, Subscription, of } from 'rxjs';
import { takeUntil, catchError } from 'rxjs/operators';
import { DataTableDirective } from 'angular-datatables';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService, MessageSeverity, DialogType } from '../../services/alert.service';
import { UserLogin } from '../../models/user-login.model';
import { ICD, MasterConfig, ResponseAPI, ErrorList } from '../../models/IDPReport.model';
import { SfDataService } from '../../services/sf-data.service';
import { AuthService } from '../../services/auth.service';
import { ConfigurationService } from '../../services/configuration.service';
import { Utilities } from '../../services/utilities';
import Swal from 'sweetalert2';



declare const $: any;


declare global {
  interface JQuery {
    datepicker(options?: any): any;
  }
}

interface JQuery<TElement = HTMLElement> {
  select2(options?: any): any;
}

interface JQuery {
  select2(options?: any): any;
}

// import custom validator to validate
import { MustMatch } from '../../models/MustMatch';
import { dateNotLessThanTodayValidator } from '../../models/dateNotLessThanTodayValidator';
import { taxIdValidator } from '../../models/taxIdValidator';
import { taxIdUniqueValidator } from '../../models/taxIdUniqueValidator';
import { AgentService, PreSubmitIssue } from '../../services/agent.service';
import { FieldIssueService } from '../../services/field-issue.service';
import { AiHintStateService } from '../../services/ai-hint-state.service';

@Component({
  selector: 'app-sf-icd-create',
  templateUrl: './sf-icd-create.component.html',
  styleUrls: ['./sf-icd-create.component.scss'],
  standalone: false
})
export class SfIcdCreateComponent implements OnInit, AfterViewInit, OnDestroy {
  icd = new ICD();
  noMiddleName: boolean = true;  // Initially checked: "ICD doesn't have a middle name" (middle name hidden/optional by default)
  private destroy$ = new Subject<void>();
  isPOICDNO: boolean = false;
  @ViewChild(DataTableDirective, { static: false })
  datatableElement: DataTableDirective;
  dtOptions: any = {};
  lstdata: any = [];
  campsdata: any = [];
  campsdatafilter: any = [];
  AccPodata: any = [];
  AccPoRepdata: any = [];
  AccPoRepdataNF: any = [];
  searchText: string = ''; // Input field value for filtering
  filteredOwners: any[] = []; // Filtered owners based on search text

  casedata: any = [];
  selected_AccPo: string;
  // Account Legal_Name__c of the selected Promoting Owner (e.g. "Raymond Dube" when
  // the Owner Name is "Ray Dube"). Due Diligence records may carry either name.
  selected_AccPoLegalName = '';
  selected_AccPoRep: string;
  isrepLoading = false;
  selected_camp: string;
  userLogin = new UserLogin();
  isLoading = false;
  btnDisplay = true;
  formResetToggle = true;
  IsFormVis = false;
  IsDueDelVis = true;
  iSDueDelYes = false;
  iSDueDelValue: string = '';
  IsPref_Differ = false;
  // Feature 10 — secondary owner
  hasSecondaryOwner = false;                 // "Does this corporation have a secondary owner?" Y/N
  noSecondaryMiddleName: boolean = true;     // "ICD doesn't have a middle name" toggle for the secondary owner (default checked)
  modalClosedCallback: () => void;
  loginStatusSubscription: any;
  selectedCountry: string;
  icdForm: FormGroup;
  @Input()
  isModal = false;
  submitted = false;
  ddlUSStates = [];
  ddlCAProvinence = [];
  PO_namesData_US = [];
  repdata: any[] = [];
  Campaigns_selectedItems: any[] = [];
  Campaigns_isSelectedItemsinvalid = false;

  PO_namesData_CA = [];
  PO_ID: string;
  public masterConfig: MasterConfig[] = [];

  showReview = false;
  reviewLoading = false;
  reviewIssues: PreSubmitIssue[] = [];
  private aiIssueCache: PreSubmitIssue[] = [];
  private formChangeSub: Subscription | null = null;

  //@ViewChild('dobInput') dobInput: ElementRef;
  @ViewChild('datepicker') datepicker: ElementRef;
  @ViewChild('selectEl') selectEl: ElementRef;

  select2Options = {
    placeholder: 'Select an option...',
    width: '100%'
  };

  selectedOption: string;
 

  controlDisplayNames: { [key: string]: string } = {

    US_or_CA: 'Country',
    Owner_First_Name: 'Owner First Name',
    Owner_Middle_Name: 'Owner Middle Name',
    Owner_Last_Name: 'Owner Last Name',
    Owner_Preferred_First_Name: 'Preferred First Name',
    Owner_Preferred_Last_Name: 'Preferred Last Name',
    Is_Preferred_Differ: 'Preferred Name Selection',
    Full_Legal_Company_Name: 'Full Legal Company Name',
    Tax_ID: 'Tax ID',
    Tax_ID_C: 'Confirm Tax ID',
    Owner_Email: 'Owner Email',
    Date_of_Incorporation: 'Date of Incorporation',

    HUB_Manager_Contact_Name: 'HUB Manager Contact Name',
    HUB_Manager_Contact_Number: 'HUB Manager Contact Number',
    HUB_Manager_Contact_Email: 'HUB Manager Contact Email',
    HUB_Manager_Contact: 'HUB Manager Contact',

    State_of_Incorporation: 'State of Incorporation',
    Provinence_of_Incorporation: 'Province of Incorporation',

    Promoting_Owner_CA: 'Promoting Owner (Canada)',
    Promoting_Owner_US: 'Promoting Owner (US)',
    CampaignName: 'Campaign Name',
    Promoting_Owner_Company: 'Promoting Owner Company'
  };

  fieldMaxLengths: any = {
    Owner_First_Name: 250,
    Owner_Middle_Name: 255,
    Owner_Last_Name: 250,
    Owner_Preferred_First_Name: 255,
    Owner_Preferred_Last_Name: 255,
    Secondary_Owner_First_Name: 250,
    Secondary_Owner_Middle_Name: 255,
    Secondary_Owner_Last_Name: 250,
    Full_Legal_Company_Name: 255,
    Tax_ID: 25,
    Tax_ID_C: 25,
    Owner_Email: 80,
    HUB_Manager_Contact_Name: 150,
    HUB_Manager_Contact_Number: 40,
    HUB_Manager_Contact_Email: 80,
    HUB_Manager_Contact: 255,
    State_of_Incorporation: 100,
    Provinence_of_Incorporation: 100,
    Promoting_Owner_CA: 150,
    Promoting_Owner_US: 150,
    CampaignName: 255,
    Promoting_Owner_Company: 255,
  };
  constructor(private cdr: ChangeDetectorRef, private elRef: ElementRef, private fb: FormBuilder, private router: Router, private alertService: AlertService, private authService: AuthService, private configurations: ConfigurationService, private sfDataService: SfDataService, private agentService: AgentService, private fieldIssueService: FieldIssueService, private hintStateService: AiHintStateService) { }



  ngOnInit(): void {


    this.CreateForm();

    this.BindDropdowns();

    //this.oniSDueDel('no');
  }

  toggleMiddleName(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      // "ICD doesn't have a middle name": hide + disable the field, drop validators,
      // and clear any value already typed so it isn't submitted.
      this.noMiddleName = true;
      this.icdForm.get('Owner_Middle_Name').clearValidators();
      this.icdForm.get('Owner_Middle_Name').setValue('');
      this.icdForm.get('Owner_Middle_Name')?.disable();
    } else {
      // User wants to enter a middle name: enable + make it required (keep length/HTML rules).
      this.noMiddleName = false;
      this.icdForm.get('Owner_Middle_Name')?.enable();
      this.icdForm.get('Owner_Middle_Name').setValidators([Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_Middle_Name), this.noHtmlTagsValidator.bind(this)]);
    }
    this.icdForm.get('Owner_Middle_Name').updateValueAndValidity();
  }

  // Feature 10 — "Does this corporation have a secondary owner?" Yes/No
  onHasSecondaryOwnerChange(value: string) {
    if (value === 'Yes') {
      this.hasSecondaryOwner = true;
      this.icdForm.get('Secondary_Owner_First_Name')?.enable();
      this.icdForm.get('Secondary_Owner_First_Name').setValidators([Validators.required, Validators.maxLength(this.fieldMaxLengths.Secondary_Owner_First_Name), this.noHtmlTagsValidator.bind(this)]);
      this.icdForm.get('Secondary_Owner_Last_Name')?.enable();
      this.icdForm.get('Secondary_Owner_Last_Name').setValidators([Validators.required, Validators.maxLength(this.fieldMaxLengths.Secondary_Owner_Last_Name), this.noHtmlTagsValidator.bind(this)]);
      // Middle name follows its own toggle (default: no middle name).
      this.noSecondaryMiddleName = true;
      this.icdForm.get('Secondary_Owner_Middle_Name').clearValidators();
      this.icdForm.get('Secondary_Owner_Middle_Name').setValue('');
      this.icdForm.get('Secondary_Owner_Middle_Name')?.disable();
    } else {
      this.hasSecondaryOwner = false;
      this.noSecondaryMiddleName = true;
      ['Secondary_Owner_First_Name', 'Secondary_Owner_Middle_Name', 'Secondary_Owner_Last_Name'].forEach(c => {
        this.icdForm.get(c).clearValidators();
        this.icdForm.get(c).setValue('');
        this.icdForm.get(c)?.disable();
        this.icdForm.get(c).updateValueAndValidity();
      });
    }
    this.icdForm.get('Secondary_Owner_First_Name').updateValueAndValidity();
    this.icdForm.get('Secondary_Owner_Last_Name').updateValueAndValidity();
  }

  // Feature 10 — "ICD doesn't have a middle name" toggle for the secondary owner
  toggleSecondaryMiddleName(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.noSecondaryMiddleName = true;
      this.icdForm.get('Secondary_Owner_Middle_Name').clearValidators();
      this.icdForm.get('Secondary_Owner_Middle_Name').setValue('');
      this.icdForm.get('Secondary_Owner_Middle_Name')?.disable();
    } else {
      this.noSecondaryMiddleName = false;
      this.icdForm.get('Secondary_Owner_Middle_Name')?.enable();
      this.icdForm.get('Secondary_Owner_Middle_Name').setValidators([Validators.required, Validators.maxLength(this.fieldMaxLengths.Secondary_Owner_Middle_Name), this.noHtmlTagsValidator.bind(this)]);
    }
    this.icdForm.get('Secondary_Owner_Middle_Name').updateValueAndValidity();
  }

  CreateForm() {
    this.icdForm = this.fb.group({
      US_or_CA: ['', Validators.required],
      Owner_First_Name: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_First_Name), this.noHtmlTagsValidator.bind(this)]],
      Owner_Middle_Name: [{ value: '', disabled: true }, [Validators.maxLength(this.fieldMaxLengths.Owner_Middle_Name), this.noHtmlTagsValidator.bind(this)]],
      Owner_Last_Name: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_Last_Name), this.noHtmlTagsValidator.bind(this)]],
      Owner_Preferred_First_Name: ['', [Validators.maxLength(this.fieldMaxLengths.Owner_Preferred_First_Name), this.noHtmlTagsValidator.bind(this)]],
      Owner_Preferred_Last_Name: ['', [Validators.maxLength(this.fieldMaxLengths.Owner_Preferred_Last_Name), this.noHtmlTagsValidator.bind(this)]],
      Is_Preferred_Differ: ['', Validators.required],
      // Feature 10 — secondary owner (fields enabled only when "Yes")
      Has_Secondary_Owner: ['', Validators.required],
      Secondary_Owner_First_Name: [{ value: '', disabled: true }, [Validators.maxLength(this.fieldMaxLengths.Secondary_Owner_First_Name), this.noHtmlTagsValidator.bind(this)]],
      Secondary_Owner_Middle_Name: [{ value: '', disabled: true }, [Validators.maxLength(this.fieldMaxLengths.Secondary_Owner_Middle_Name), this.noHtmlTagsValidator.bind(this)]],
      Secondary_Owner_Last_Name: [{ value: '', disabled: true }, [Validators.maxLength(this.fieldMaxLengths.Secondary_Owner_Last_Name), this.noHtmlTagsValidator.bind(this)]],
      Full_Legal_Company_Name: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Full_Legal_Company_Name), this.noHtmlTagsValidator.bind(this)]],
      Tax_ID: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Tax_ID), this.noHtmlTagsValidator.bind(this), taxIdValidator()], [taxIdUniqueValidator(this.sfDataService)]],
      Tax_ID_C: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Tax_ID_C), this.noHtmlTagsValidator.bind(this)]],
      Owner_Email: [
        '',
        [
          Validators.required,
          Validators.maxLength(this.fieldMaxLengths.Owner_Email),
          Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/),
          this.noHtmlTagsValidator.bind(this)
        ]
      ],
      Date_of_Incorporation: ['', [Validators.required, Validators.pattern(/^(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])\-\d{4}$/)]],

      HUB_Manager_Contact_Name: [{ value: '', disabled: true }],
      HUB_Manager_Contact_Number: [{ value: '', disabled: true }],
      HUB_Manager_Contact_Email: [{ value: '', disabled: true }],
      HUB_Manager_Contact: ['', [Validators.maxLength(this.fieldMaxLengths.HUB_Manager_Contact), this.noHtmlTagsValidator.bind(this)]],
      State_of_Incorporation: ['', Validators.required],
      Provinence_of_Incorporation: ['', Validators.required],
      Promoting_Owner_CA: [''],
      Promoting_Owner_US: [''],
      CampaignName: ['', [Validators.maxLength(this.fieldMaxLengths.CampaignName), this.noHtmlTagsValidator.bind(this)]],
      Promoting_Owner_Company: [{ value: '', disabled: true }]
    }, {
      validators: MustMatch('Tax_ID', 'Tax_ID_C')
    });


    let user = this.authService.currentUser;

    if (user != null) {

      this.icdForm.controls['HUB_Manager_Contact_Email'].setValue(user.email);
      this.icdForm.controls['HUB_Manager_Contact_Name'].setValue(user.fullName);
      this.icdForm.controls['HUB_Manager_Contact_Number'].setValue(user.jobTitle);
    }
  }


  // convenience getter for easy access to form fields
  get f() { return this.icdForm.controls; }

  ShowOTPpopup() {
    Swal.fire({
      title: 'New ICD Request Submitted Successfully!',
      icon: 'success',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,

      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (val) {

        }
      },
    }).then((result) => {
      let url = '/changerequest/';
      this.router.navigate([url]);
    });
  }
  filterOwners() {
    // Ensure the search text is at least 3 characters long before filtering
    if (this.searchText.trim().length >= 3) {

      // Log owners with empty or invalid ownerName
      const invalidOwners = this.AccPodata.filter(owner =>
        !owner || !owner.ownerName || owner.ownerName.trim() === ''
      );
      //console.log('Owners with empty or invalid ownerName:', invalidOwners);

      // Safely filter owners based on the search text and exclude test accounts
      this.filteredOwners = this.AccPodata.filter(owner =>
        // Ensure ownerName is not null/undefined and call toLowerCase() only on a valid string
        (owner?.ownerName ?? '').toLowerCase().includes(this.searchText.toLowerCase()) &&
        // Keep only accounts where Test_Account__c is false
        owner?.test_Account__c == 'false'
      );

      //console.log(this.filteredOwners);

    } else {
      // Clear the table and selection if search text length is less than 3
      this.filteredOwners = [];
      this.selected_AccPo = '';
      this.selected_AccPoLegalName = '';
    }
  }

  selectOwner(owner: any) {
    // Handle selection logic here, e.g., emit an event or update a property
    //console.log('Selected Owner:', owner);
  }

  togglePOICDO(event) {

    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.isPOICDNO = isChecked;
      this.onCheckbox_AccPORepOwnerName(this.selected_AccPo);

    } else {
      this.isPOICDNO = false;

      this.onCheckbox_AccPORep('');
     
    }
  }

  onCheckboxPo_US(selectElement) {

    if (selectElement != null) {
      const selectedIndex = this.PO_namesData_US.filter(item => item.ownerName == selectElement);


      if (selectedIndex.length >= 0) {
        this.PO_ID = selectedIndex[0].id;
        this.icdForm.controls['Promoting_Owner_Company'].setValue(selectedIndex[0].name);
      } else {
        this.PO_ID = '';
        this.icdForm.controls['Promoting_Owner_Company'].setValue('');
      }

    }


  }


  onCheckboxPo_CA(selectElement) {

    if (selectElement != null) {
      const selectedIndex = this.PO_namesData_CA.filter(item => item.ownerName == selectElement);


      if (selectedIndex.length >= 0) {
        this.PO_ID = selectedIndex[0].id;
        this.icdForm.controls['Promoting_Owner_Company'].setValue(selectedIndex[0].name);
      } else {
        this.PO_ID = '';
        this.icdForm.controls['Promoting_Owner_Company'].setValue('');
      }

    }


  }





  onCheckboxChange_Campaigns(event: any, value: any) {
    if (event.target.checked) {
      this.Campaigns_selectedItems.push(value);
    } else {
      const index = this.Campaigns_selectedItems.indexOf(value);
      if (index > -1) {
        this.Campaigns_selectedItems.splice(index, 1);
      }
    }


    if (this.Campaigns_selectedItems.length <= 0) {
      this.Campaigns_isSelectedItemsinvalid = true;
    }
    else {
      this.Campaigns_isSelectedItemsinvalid = false;
    }


  }



  Showsuccesspopup1(str: string) {
    Swal.fire({
      title: str,
      icon: 'error',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,

      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (val) {

          //location.reload();
        }
      },
    }).then((result) => {

    });
  }

  onCheckbox_AccPO(selectElement: any) {
    if (selectElement != null) {
      // this.selected_AccPo = selectElement;
      this.selected_AccPo = selectElement.ownerName;
      this.selected_AccPoLegalName = selectElement.legalName ?? '';
      this.AccPoRepdata = [];
      this.AccPoRepdataNF = [];

      // Changing the Promoting Owner invalidates the previously chosen New ICD
      // Owner and its campaign list. Reset that downstream selection (and the
      // "Existing Owner Opening a New Corp" toggle) so nothing stale lingers
      // while fresh reps/campaigns load for the newly selected owner.
      this.isPOICDNO = false;
      this.resetRepAndCampaignSelection();

      this.isLoading = true;

      this.alertService.startLoadingMessage('', 'Data loading...');
      this.sfDataService.GetAccountReps(selectElement.ownerName, this.selected_camp).pipe(takeUntil(this.destroy$)).subscribe(resp => {
        //console.log(resp);
        //this.AccPoRepdata = resp;
        this.AccPoRepdataNF = resp;
        const sorted = resp.sort((a, b) =>
          new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
        );
        this.AccPoRepdata = sorted.filter((item, index, self) =>
          index === self.findIndex((t) => t.icD_Rep_Name === item.icD_Rep_Name)
        );

        this.AccPoRepdata.forEach(item => {
          // Assuming you have a function called dateFormat to format the date
          item.closedDate = this.formatDate(item.closedDate);
        });

        this.alertService.stopLoadingMessage();
        this.isLoading = false;
        this.isrepLoading = true;

        // "Existing Owner Opening a New Corp" flow derives its campaign list from the
        // owner name. That recompute normally runs on toggle change, so re-run it here
        // (now that fresh rep data has loaded) whenever the toggle is already on.
        if (this.isPOICDNO) {
          this.onCheckbox_AccPORepOwnerName(this.selected_AccPo);
        }
        ////console.log(this.NC_namesData)

        ////console.log(this.Canada_campaignData)
      });

    }
    else {
      this.selected_AccPo = "";
      this.selected_AccPoLegalName = "";
      this.isrepLoading = false;
      this.AccPoRepdataNF = [];
      this.AccPoRepdata = [];
      this.isPOICDNO = false;
      this.resetRepAndCampaignSelection();
    }
  }

  /**
   * Clear the New ICD Owner / campaign selection state so switching the Promoting
   * Owner (or toggling Due Diligence) never leaves a stale rep, campaign list, or
   * checked campaign behind.
   */
  private resetRepAndCampaignSelection(): void {
    this.selected_AccPoRep = "";
    this.repdata = [];
    this.campsdatafilter = [];
    this.Campaigns_selectedItems = [];
    this.Campaigns_isSelectedItemsinvalid = false;
  }

  /**
   * Rebuild the campaign list for the current rep selection.
   *
   * - Keeps only campaigns tied to the selected rep's records.
   * - Collapses duplicates to one row per distinct campaign name (Add_Campaign_s__c
   *   is keyed by campaign name, so two master rows sharing a name are the same
   *   selectable campaign — showing both let a single click check both).
   * - Clears any previously checked campaign, so a campaign selected under a
   *   PREVIOUS rep can never linger and get submitted alongside the new one.
   */
  private buildCampaignFilter(): void {
    // Campaign reason depends on the selected flow:
    //  - "Existing Owner Opening a New Corp" (isPOICDNO) → "My Own Office"
    //  - selecting a New ICD Owner from the dropdown       → "Potential New ICD"
    // Only campaigns tied to a rep record with the matching reason are offered.
    const expectedReason = this.isPOICDNO ? 'my own office' : 'potential new icd';
    const relevantReps = this.repdata.filter((rep: any) =>
      (rep.reason ?? '').toString().trim().toLowerCase() === expectedReason
    );

    const filtered = this.campsdata.filter((camp: any) =>
      relevantReps.some(rep => rep.campaign_Name === camp.campaignName)
    );

    const seen = new Set<string>();
    this.campsdatafilter = filtered.filter((camp: any) => {
      const key = (camp.campaignName ?? '').toString().trim().toLowerCase();
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });

    this.Campaigns_selectedItems = [];
    this.Campaigns_isSelectedItemsinvalid = false;
  }

  formatDate(dateString: string): string {
    if (dateString && typeof dateString === 'string') {
      // Extracting date and time part
      const dateTimeParts = dateString.split('T');
      if (dateTimeParts.length === 2) {
        const datePart = dateTimeParts[0];
        const timePart = dateTimeParts[1].split('.')[0]; // Removing milliseconds

        // Constructing formatted date
        const formattedDate = new Date(datePart + ' ' + timePart + 'Z').toLocaleString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });

        return formattedDate;
      }
    }
    return dateString;
  }

  proceed() {

    if (this.Campaigns_selectedItems.length > 0) {
      this.IsDueDelVis = false;

      this.IsFormVis = true;
      this.icdForm.controls['US_or_CA'].setValue(this.repdata[0].account_Country);
      this.onCountryChange();

      if (this.isPOICDNO) {
        this.icdForm.controls['Owner_First_Name'].setValue(this.repdata[0].icD_Owner_Name__c.split(' ')[0]);
        this.icdForm.controls['Owner_Last_Name'].setValue(this.repdata[0].icD_Owner_Name__c.split(' ')[1]);
      } else {
        this.icdForm.controls['Owner_First_Name'].setValue(this.repdata[0].icD_Rep_Name.split(' ')[0]);
        this.icdForm.controls['Owner_Last_Name'].setValue(this.repdata[0].icD_Rep_Name.split(' ')[1]);
      }
      
      if (this.isPOICDNO) {
        // "Existing Owner Opening a New Corp": do NOT prefill the Promoting Owner.
        // The user selects the Promoting Owner (and its Company) manually on the form.
        this.icdForm.controls['Promoting_Owner_US'].setValue('');
        this.icdForm.controls['Promoting_Owner_CA'].setValue('');
        this.icdForm.controls['Promoting_Owner_Company'].setValue('');
        this.PO_ID = '';
      }
      else if (this.repdata[0].account_Country === 'US') {
        this.icdForm.controls['Promoting_Owner_US'].setValue(this.selected_AccPo);
        this.onCheckboxPo_US(this.selected_AccPo);
      }
      else {
        this.icdForm.controls['Promoting_Owner_CA'].setValue(this.selected_AccPo);
        this.onCheckboxPo_CA(this.selected_AccPo);
      }

    }
    else {
      this.alertService.showMessage('Campaign', `Please select min 1 campaign listed`, MessageSeverity.error);
    }

  }

  onCheckbox_AccPORep(selectElement) {
    if (selectElement != null) {
      this.selected_AccPoRep = selectElement;

      this.repdata = this.AccPoRepdataNF
        .filter((a: any) => a.icD_Rep_Name == selectElement)
        .filter((rep: any) => this.isClosedWithin90Days(rep));

      this.isLoading = true;
      // //console.log(repdata.campaign_Name);
      //this.alertService.startLoadingMessage('', 'Data loading...');

      //this.campsdatafilter = this.campsdata.filter(a => a.campaignName == this.repdata[0].campaign_Name);

      this.buildCampaignFilter();

      //this.campsdatafilter = this.campsdata;
      ////console.log(this.campsdatafilter);
      //this.alertService.stopLoadingMessage();
      //this.isLoading = false;
      //this.IsDueDelVis = false;

      //this.IsFormVis = true;
      //this.icdForm.controls['US_or_CA'].setValue(repdata[0].account_Country);
      //this.onCountryChange();


      //this.icdForm.controls['Owner_First_Name'].setValue(repdata[0].icD_Rep_Name.split(' ')[0]);
      //this.icdForm.controls['Owner_Last_Name'].setValue(repdata[0].icD_Rep_Name.split(' ')[1]);
      //if (repdata[0].account_Country === 'US') {
      //  this.icdForm.controls['Promoting_Owner_US'].setValue(this.selected_AccPo);
      //  this.onCheckboxPo_US(this.selected_AccPo);
      //}
      //else {
      //  this.icdForm.controls['Promoting_Owner_CA'].setValue(this.selected_AccPo);
      //  this.onCheckboxPo_CA(this.selected_AccPo);
      //}

      //this.sfDataService.GetCaseData(this.selected_camp,selectElement).subscribe(resp => {

      //  if (this.casedata != null && this.casedata.length > 0) {



      //  }
      //  else {
      //    this.alertService.showStickyMessage('No case data available : ', this.mapLoginErrorMessage(this.selected_camp + " - " + repdata[0].full_Name), MessageSeverity.error, "");
      //  }

      //});
    }
    else {
      this.selected_AccPoRep = "";
    }
  }

  onCheckbox_AccPORepOwnerName(selectElement) {
    if (selectElement != null) {
      this.selected_AccPoRep = selectElement;

      this.repdata = this.AccPoRepdataNF
        .filter((a: any) => a.icD_Owner_Name__c == selectElement)
        // "Existing Owner Opening a New Corp": only the owner's own records count.
        // The rep name must be empty/null OR the owner's Owner Name or Legal Name
        // (e.g. "Ray Dube" / "Raymond Dube") — records that belong to a different
        // rep must be excluded.
        .filter((rep: any) => {
          const repName = this.normalizeName(rep.icD_Rep_Name);
          return repName === '' || this.isSelectedOwnerName(repName, rep.icD_Owner_Name__c);
        })
        .filter((rep: any) => this.isClosedWithin90Days(rep));

      this.isLoading = true;
      // //console.log(repdata.campaign_Name);
      //this.alertService.startLoadingMessage('', 'Data loading...');

      //this.campsdatafilter = this.campsdata.filter(a => a.campaignName == this.repdata[0].campaign_Name);

      this.buildCampaignFilter();

    }
    else {
      this.selected_AccPoRep = "";
    }
  }

  /**
   * True if a rep/case record has no closed date, or was closed within the last 90 days.
   * Records closed more than 90 days ago are excluded (the "90 days rule").
   *
   * The closed date lives in different fields depending on the record type merged
   * by GetCaseDataAcc:
   *   Case records          -> closedDate  (Salesforce "ClosedDate")
   *   SCI_Due_Diligence__c  -> closed_Date__c
   * Check every known variant so the rule applies to BOTH record types
   * (previously only closed_Date__c was checked, so old Case records slipped through).
   */
  private isClosedWithin90Days(rep: any): boolean {
    const rawDate =
      rep?.closed_Date__c ?? rep?.closedDate ?? rep?.closed_date ??
      rep?.Closed_Date__c ?? rep?.ClosedDate ?? null;
    if (!rawDate) {
      // no closed date -> allowed
      return true;
    }
    let parsed = Date.parse(String(rawDate));
    if (isNaN(parsed)) {
      // fall back to the date portion before the time separator
      const idx = String(rawDate).indexOf('T');
      if (idx > 0) {
        parsed = Date.parse(String(rawDate).substring(0, idx));
      }
    }
    if (isNaN(parsed)) {
      // unable to parse -> exclude
      return false;
    }
    const diffDays = (new Date().getTime() - parsed) / (1000 * 60 * 60 * 24);
    return diffDays <= 90;
  }

  oniSDueDel(yesorno) {
    this.iSDueDelValue = yesorno;

    // Whenever the Due Diligence answer changes, clear any owner/rep/campaign
    // selection made under the previous answer. Without this, a campaign chosen
    // under "Yes" (but never confirmed via Proceed) would still be submitted
    // after switching to "No".
    this.resetDueDiligenceSelection();

    if (yesorno == 'Yes') {
      this.IsDueDelVis = true;
      this.IsFormVis = false;
      this.iSDueDelYes = true;
    }
    else {
      this.IsDueDelVis = false;
      this.IsFormVis = true;
      this.iSDueDelYes = false;
    }
  }

  /**
   * Full reset of the Due Diligence area. Used when the "participating in Due
   * Diligence Campaigns?" answer changes, so a previously selected owner/rep/
   * campaign can never carry over into submission without going through Proceed.
   */
  private resetDueDiligenceSelection(): void {
    this.selected_AccPo = "";
    this.selected_AccPoLegalName = "";
    this.searchText = "";
    this.filteredOwners = [];
    this.isPOICDNO = false;
    this.isrepLoading = false;
    this.AccPoRepdata = [];
    this.AccPoRepdataNF = [];
    this.resetRepAndCampaignSelection();
  }

  showAllDueDiligenceCampaigns() {
    // Filter campaigns that require due diligence
    const dueDiligenceCampaigns = this.campsdata.filter(camp => camp.dueDiligenceRequired === "Yes");
    
    if (dueDiligenceCampaigns.length === 0) {
      this.alertService.showMessage('Due Diligence Campaigns', 'No due diligence campaigns available', MessageSeverity.info);
      return;
    }

    // Create formatted list of campaigns
    const campaignList = dueDiligenceCampaigns
      .map(camp => `• ${camp.campaignName} (${camp.name})`)
      .join('\n');

    // Show modal with all campaigns
    Swal.fire({
      title: 'Due Diligence Campaigns',
      html: `<div style="text-align: left; margin: 20px 0;">
        <p><strong>Available Due Diligence Campaigns:</strong></p>
        <pre style="white-space: pre-wrap; word-wrap: break-word; background-color: #f5f5f5; padding: 15px; border-radius: 4px; max-height: 400px; overflow-y: auto;">
${campaignList}
        </pre>
        <p style="font-size: 12px; color: #666; margin-top: 15px;">
          Select "Yes" above and then choose a Promoting Owner and New ICD Owner to see associated campaigns.
        </p>
      </div>`,
      icon: 'info',
      confirmButtonText: 'Close',
      width: '600px'
    });
  }

  onCountryChange() {
    const US_or_CA = this.icdForm.get('US_or_CA').value;
    if (US_or_CA === 'US') {
      this.selectedCountry = "US";
      this.icdForm.get('State_of_Incorporation').setValidators([Validators.required]);
      this.icdForm.get('Provinence_of_Incorporation').clearValidators();

      this.icdForm.get('Promoting_Owner_US').setValidators([Validators.required]);
      this.icdForm.get('Promoting_Owner_CA').clearValidators();
    } else {
      this.selectedCountry = "Canada";
      this.icdForm.get('Provinence_of_Incorporation').setValidators([Validators.required]);
      this.icdForm.get('State_of_Incorporation').clearValidators();


      this.icdForm.get('Promoting_Owner_CA').setValidators([Validators.required]);
      this.icdForm.get('Promoting_Owner_US').clearValidators();
    }
    this.icdForm.get('Provinence_of_Incorporation').updateValueAndValidity();
    this.icdForm.get('State_of_Incorporation').updateValueAndValidity();

    this.icdForm.get('Promoting_Owner_CA').updateValueAndValidity();
    this.icdForm.get('Promoting_Owner_US').updateValueAndValidity();
  }



  onIsPreferChange(Is_Preferred_Differ) {

    if (Is_Preferred_Differ === 'Yes') {
      this.IsPref_Differ = true;
      this.icdForm.get('Owner_Preferred_First_Name').setValidators([Validators.required]);
      this.icdForm.get('Owner_Preferred_Last_Name').setValidators([Validators.required]);

    } else {
      this.IsPref_Differ = false;
      this.icdForm.get('Owner_Preferred_First_Name').clearValidators();
      this.icdForm.get('Owner_Preferred_Last_Name').clearValidators();
      this.icdForm.controls['Owner_Preferred_First_Name'].setValue('');
      this.icdForm.controls['Owner_Preferred_Last_Name'].setValue('');
    }
    this.icdForm.get('Owner_Preferred_First_Name').updateValueAndValidity();
    this.icdForm.get('Owner_Preferred_Last_Name').updateValueAndValidity();

  }

  showErrorAlert(caption: string, message: string) {
    this.alertService.showMessage(caption, message, MessageSeverity.error);
  }

  //ngAfterViewInit() {

  //  this.datepicker = $('#Date_of_Incorporation').datepicker({
  //    dateFormat: 'mm-dd-yy',
  //    changeMonth: true,
  //    changeYear: true,
  //    maxDate: 0,
  //    onSelect: (dateText, inst) => {
  //      this.datepicker = dateText;
  //      this.icdForm.controls['Date_of_Incorporation'].patchValue(dateText);
  //      this.icdForm.controls['Date_of_Incorporation'].markAsTouched();
  //      this.icdForm.controls['Date_of_InCorporation'].updateValueAndValidity();
  //    }
  //  });

  //  this.cdr.detectChanges();
  //  //if (this.selectEl) {
  //  //  $(this.selectEl.nativeElement).select2({ width: '100%' });
  //  //};

  //  setTimeout(() => {
  //    $('.select2', this.elRef.nativeElement).select2();
  //  }, 0);
  //  $('.select2').select();
  //  //$(this.datepicker.nativeElement).datepicker({
  //  //  dateFormat: 'yyyy-mm-dd',
  //  //  autoclose: true,
  //  //  onSelect: (date) => {
  //  //    this.dobInput.nativeElement.value = date;
  //  //  }
  //  //});

  //  //$('.select2').select2(); //initialize
  //}


  ngAfterViewInit(): void {
    setTimeout(() => {
      $('#Date_of_Incorporation').datepicker({
        dateFormat: 'mm-dd-yy',
        changeMonth: true,
        changeYear: true,
        maxDate: 0,
        onSelect: (dateText: string) => {
          this.icdForm.controls['Date_of_Incorporation'].setValue(dateText);
          this.icdForm.controls['Date_of_Incorporation'].markAsTouched();
        }
      });

      $('.select2', this.elRef.nativeElement).select2();
    });
  }

  closeModal() {
    if (this.modalClosedCallback) {
      this.modalClosedCallback();
    }
  }

  private fieldLabels: Record<string, string> = {
    US_or_CA:                   'Country',
    Owner_First_Name:           'Owner First Name',
    Owner_Middle_Name:          'Owner Middle Name',
    Owner_Last_Name:            'Owner Last Name',
    Owner_Preferred_First_Name: 'Preferred First Name',
    Owner_Preferred_Last_Name:  'Preferred Last Name',
    Is_Preferred_Differ:        'Preferred Name Selection',
    Full_Legal_Company_Name:    'Full Legal Company Name',
    Tax_ID:                     'F.E.I.N. Tax ID',
    Tax_ID_C:                   'Confirm Tax ID',
    Owner_Email:                'Owner Email',
    Date_of_Incorporation:      'Date of Incorporation',
    State_of_Incorporation:     'State of Incorporation',
    Provinence_of_Incorporation:'Province of Incorporation',
    Promoting_Owner_US:         'Promoting Owner (US)',
    Promoting_Owner_CA:         'Promoting Owner (CA)',
    CampaignName:               'Campaign Name',
  };

  private angularErrorsToIssues(): PreSubmitIssue[] {
    const issues: PreSubmitIssue[] = [];
    const errorMessages: Record<string, string> = {
      required:              'This field is required',
      email:                 'Invalid email format',
      dateNotLessThanToday:  'Date must not be in the future',
      mustMatch:             'Must match the Tax ID field',
      minlength:             'Value is too short',
      maxlength:             'Value is too long',
      pattern:               'Invalid format',
      invalidHtml:           'HTML/script content is not allowed',
    };
    Object.keys(this.icdForm.controls).forEach(fieldName => {
      const ctrl = this.icdForm.get(fieldName);
      if (ctrl && ctrl.invalid && ctrl.errors) {
        const firstErrorKey = Object.keys(ctrl.errors)[0];
        const errVal = ctrl.errors[firstErrorKey];
        const isRich = errVal !== null && typeof errVal === 'object' && 'message' in errVal;
        issues.push({
          fieldName,
          label: (isRich && errVal.label) ? errVal.label : (this.fieldLabels[fieldName] ?? fieldName),
          issue: isRich ? errVal.message : (errorMessages[firstErrorKey] ?? `Invalid value (${firstErrorKey})`),
          severity: 'error',
          suggestedFix: isRich ? (errVal.suggestedFix ?? null) : null,
          canAutoFix: isRich ? (errVal.canAutoFix ?? false) : false,
        });
      }
    });
    return issues;
  }

  onSubmit() {
    this.hintStateService.collapse();
    this.trimFormValues();
    this.submitted = true;
    this.icdForm.markAllAsTouched();

    const angularIssues = this.angularErrorsToIssues();
    const snapshot = this.buildSnapshot();

    this.showReview = true;
    this.reviewLoading = true;
    this.reviewIssues = angularIssues;
    this.fieldIssueService.setIssues([]); // clear inline; Angular form shows its own errors
    this.cdr.detectChanges(); // force modal to render immediately before async call

    this.startFormChangeTracking();

    this.agentService.getPreSubmitReview(snapshot).pipe(
      catchError(() => of({ issues: [] }))
    ).subscribe(res => {
      this.aiIssueCache = res?.issues ?? [];
      const merged = this.mergeIssues(this.angularErrorsToIssues(), this.aiIssueCache);
      this.reviewLoading = false;
      this.reviewIssues = merged;
      this.fieldIssueService.setIssues(this.aiIssueCache); // only AI issues shown inline
      this.cdr.detectChanges();
    });
  }

  onReviewAutoFix(issue: PreSubmitIssue): void {
    const ctrl = this.icdForm.get(issue.fieldName);
    if (issue.suggestedFix != null && ctrl) {
      ctrl.setValue(issue.suggestedFix, { emitEvent: true });
      ctrl.markAsDirty();
      ctrl.markAsTouched();
      ctrl.updateValueAndValidity();
    }
    this.onReviewRecheck();
  }

  onReviewRecheck(): void {
    const angularIssues = this.angularErrorsToIssues();
    const snapshot = this.buildSnapshot();
    this.reviewLoading = true;
    this.reviewIssues = angularIssues;
    this.fieldIssueService.setIssues([]);
    this.agentService.getPreSubmitReview(snapshot).pipe(
      catchError(() => of({ issues: [] }))
    ).subscribe(res => {
      this.aiIssueCache = res?.issues ?? [];
      const merged = this.mergeIssues(this.angularErrorsToIssues(), this.aiIssueCache);
      this.reviewLoading = false;
      this.reviewIssues = merged;
      this.fieldIssueService.setIssues(this.aiIssueCache);
      this.cdr.detectChanges();
    });
  }

  onReviewSubmit(): void {
    this.showReview = false;
    this.stopFormChangeTracking();
    this.fieldIssueService.clearIssues();
    this.saveData();
  }

  onReviewDismiss(): void {
    this.showReview = false;
    this.stopFormChangeTracking();
    this.fieldIssueService.clearIssues();
    this.aiIssueCache = [];
  }

  onReviewNavigate(fieldName: string): void {
    this.showReview = false;
    setTimeout(() => {
      const el =
        document.querySelector<HTMLElement>(`[formControlName="${fieldName}"]`) ??
        document.querySelector<HTMLElement>(`#${fieldName}`);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        el.focus?.();
      }
    }, 180);
  }

  private buildSnapshot(): Record<string, string> {
    const raw = this.icdForm.getRawValue();
    const snapshot: Record<string, string> = {};
    Object.keys(raw).forEach(k => { snapshot[k] = raw[k] != null ? String(raw[k]) : ''; });
    return snapshot;
  }

  private mergeIssues(angularIssues: PreSubmitIssue[], aiIssues: PreSubmitIssue[]): PreSubmitIssue[] {
    // Angular validators are authoritative for format/required checks.
    // AI issues are only shown for fields Angular considers valid.
    const angularErrorFields = new Set(angularIssues.map(i => i.fieldName));
    const additionalAiIssues = aiIssues.filter(i => !angularErrorFields.has(i.fieldName));
    return [...angularIssues, ...additionalAiIssues];
  }

  private startFormChangeTracking(): void {
    this.stopFormChangeTracking();
    this.formChangeSub = this.icdForm.valueChanges.subscribe(() => {
      const angularIssues = this.angularErrorsToIssues();
      const merged = this.mergeIssues(angularIssues, this.aiIssueCache);
      this.reviewIssues = merged;
      this.fieldIssueService.setIssues(this.aiIssueCache); // only AI issues inline
    });
  }

  private stopFormChangeTracking(): void {
    this.formChangeSub?.unsubscribe();
    this.formChangeSub = null;
  }

  saveData() {
    //debugger;
    this.isLoading = true;
    this.btnDisplay = false;
    this.alertService.startLoadingMessage('', 'Data Submitting...');

    // Clear async validators immediately so any in-flight taxIdUniqueValidator call
    // cannot update the UI after the record has been submitted to Salesforce.
    const taxIdCtrl = this.icdForm.get('Tax_ID');
    if (taxIdCtrl) {
      taxIdCtrl.clearAsyncValidators();
      taxIdCtrl.updateValueAndValidity({ emitEvent: false });
    }

    // Get the form values as an object
    const formValues = this.icdForm.getRawValue();


    // Create a new instance of the ICD class
    const icd = new ICD(); let responseAPI = new ResponseAPI();

    // Set the properties of the ICD instance with the form values
    icd.US_or_CA = formValues.US_or_CA;
    icd.Owner_First_Name = formValues.Owner_First_Name;
    icd.Owner_Middle_Name = formValues.Owner_Middle_Name || '';

    icd.Owner_Last_Name = formValues.Owner_Last_Name;
    icd.Owner_Preferred_First_Name = formValues.Owner_Preferred_First_Name;
    icd.Owner_Preferred_Last_Name = formValues.Owner_Preferred_Last_Name;
    icd.Full_Legal_Company_Name = formValues.Full_Legal_Company_Name;
    icd.Tax_ID = formValues.Tax_ID;
    icd.Tax_ID_C = formValues.Tax_ID_C;
    icd.Owner_Email = formValues.Owner_Email;
    icd.Date_of_Incorporation = formValues.Date_of_Incorporation;
    icd.HUB_Manager_Contact_Name = formValues.HUB_Manager_Contact_Name;
    icd.HUB_Manager_Contact_Number = formValues.HUB_Manager_Contact_Number;
    icd.HUB_Manager_Contact_Email = formValues.HUB_Manager_Contact_Email;
    icd.HUB_Manager_Contact = formValues.HUB_Manager_Contact;
    icd.Preferred_Name_Different_from_Legal_Name__c = formValues.Is_Preferred_Differ;

    // Feature 10 — secondary owner
    icd.Has_Secondary_Owner = formValues.Has_Secondary_Owner;
    if (formValues.Has_Secondary_Owner === 'Yes') {
      icd.Secondary_Owner_First_Name = formValues.Secondary_Owner_First_Name;
      icd.Secondary_Owner_Middle_Name = formValues.Secondary_Owner_Middle_Name || '';
      icd.Secondary_Owner_Last_Name = formValues.Secondary_Owner_Last_Name;
    } else {
      icd.Secondary_Owner_First_Name = '';
      icd.Secondary_Owner_Middle_Name = '';
      icd.Secondary_Owner_Last_Name = '';
    }

    icd.PromotingOwnerCompany = formValues.Promoting_Owner_Company;
    if (icd.US_or_CA == "US") {
      icd.State_of_Incorporation = formValues.State_of_Incorporation;
      icd.Provinence_of_Incorporation = "";
      icd.PromotingOwner = formValues.Promoting_Owner_US;
    }
    else {
      icd.Provinence_of_Incorporation = formValues.Provinence_of_Incorporation;
      icd.State_of_Incorporation = "";
      icd.PromotingOwner = formValues.Promoting_Owner_CA;
    }

    icd.PromotingOwnerId = this.PO_ID;
    // Only send campaigns when the user confirmed the Due Diligence selection via
    // Proceed (which sets IsDueDelVis = false). Dedupe defensively so a campaign can
    // never be submitted more than once.
    if (this.Campaigns_selectedItems.length > 0 && !this.IsDueDelVis) {

      const uniqueCampaigns = [...new Set(this.Campaigns_selectedItems)];

      const campaignsString = uniqueCampaigns.join(', ');

      icd.Selected_camp = campaignsString;
    }

    Swal.fire({
      title: 'Submitting data...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    this.sfDataService.CreateICD(icd)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          Swal.close();
          //responseAPI = data;
          // Assign the received data to the responseAPI object
          responseAPI = data;
          if (responseAPI.isSuccess && !responseAPI.isValidationError) {

            setTimeout(() => {
              this.alertService.showMessage('ICD', `Data Saved Successfully`, MessageSeverity.success);
              this.alertService.stopLoadingMessage();
              this.isLoading = false;
              this.submitted = false;
              this.reset();
              this.cdr.detectChanges(); // ensure form is removed from DOM before success modal opens
              this.alertService.showStickyMessage('Data Saved successfully', "", MessageSeverity.success, "");
              this.ShowOTPpopup();
              //this.CreateForm();

              //this.BindDropdowns();

              //if (responseAPI.data != null) {
              //  let url = '/icd/icdinfo/' + responseAPI.data;
              //this.router.navigate([url]);
              //}


            }, 500);
          }
          else {

            const errors: ErrorList | null = responseAPI.data ?? null;
            //setTimeout(() => {
            this.alertService.showMessage('ICD', `Error while saving Data`, MessageSeverity.error);
            this.alertService.stopLoadingMessage();
            this.isLoading = false;
            this.alertService.showStickyMessage('Unable to store data', errors?.error?.message ?? 'An error occurred while saving data', MessageSeverity.error, errors?.error?.errorCode);

            this.btnDisplay = true;

            //}, 200);

          }

        },
        error => {
          Swal.close();
          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            this.offerAlternateHost();
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to store data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to store data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });
  }

  BindDropdowns() {
    //debugger;
    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Data loading...');

    //this.icd.Owner_Email = this.icdForm.value["Owner_email"];
    this.sfDataService.getMasterConfigs("US_State,Canada_Province")
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          ////console.log(data);
          //debugger;
          this.masterConfig = data;
          this.ddlUSStates = this.masterConfig.filter(a => a.type == "US_State");
          this.ddlCAProvinence = this.masterConfig.filter(a => a.type == "Canada_Province");
          this.alertService.stopLoadingMessage();
        },
        error => {

          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            this.offerAlternateHost();
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to get data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to get data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });


    this.sfDataService.getAddInfoDDs().pipe(takeUntil(this.destroy$)).subscribe(resp => {
      ////console.log(resp);

      let res: any;

      res = resp;

      this.PO_namesData_US = res.poNames.filter(item => !item.name.startsWith('test') && !item.name.startsWith('smart circle')).filter(a => a.uS_or_Canada == "US");
      this.PO_namesData_CA = res.poNames.filter(item => !item.name.startsWith('test') && !item.name.startsWith('smart circle')).filter(a => a.uS_or_Canada == "Canada");
      //$('.select2').select();
      ////console.log(this.NC_namesData)

      ////console.log(this.Canada_campaignData)
    });


    this.sfDataService.getCMReports().pipe(takeUntil(this.destroy$)).subscribe(resp => {
      ////console.log(resp);


      this.campsdata = resp.filter(a => a.dueDiligenceRequired == "Yes");;

      //$('.select2').select();
      ////console.log(this.NC_namesData)

      ////console.log(this.Canada_campaignData)
    });


    this.sfDataService.GetAccountHubs().pipe(takeUntil(this.destroy$)).subscribe(resp => {
      ////console.log(resp);
      this.AccPodata = resp;

      ////console.log(this.NC_namesData)

      ////console.log(this.Canada_campaignData)
    });

  }


  trimFormValues() {

    // Avoid setting value on file inputs. Skip controls that look like file attachments
    // (names starting with "Attach_") or whose value is a File/FileList/object.
    Object.keys(this.icdForm.controls).forEach(key => {
      // Skip known file-type controls
      if (/^Attach_/i.test(key) || /Attach/i.test(key)) {
        return;
      }

      const control = this.icdForm.get(key);
      if (!control) {
        return;
      }

      const val = control.value;

      // Skip File / FileList / object values to avoid InvalidStateError
      if (val instanceof File || (typeof FileList !== 'undefined' && val instanceof FileList) || typeof val === 'object') {
        return;
      }

      if (typeof val === 'string') {
        try {
          control.setValue(val.trim());
        } catch (e) {
          // don't break form processing on single control error
          console.warn(`trimFormValues: skipped trimming control '${key}' due to error`, e);
        }
      }
    });
  }
  getDistinctColumnValues(data: any[], columnName: string): string[] {
    const columnValues = data.map(item => item[columnName]);
    return [...new Set(columnValues)];
  }

  mapLoginErrorMessage(error: string) {

    if (error === 'invalid_username_or_password') {
      return 'Invalid username or password';
    }

    if (error === 'invalid_grant') {
      return 'This account has been disabled';
    }

    return error;
  }

  offerAlternateHost() {

    if (Utilities.checkIsLocalHost(location.origin) && Utilities.checkIsLocalHost(this.configurations.baseUrl)) {
      this.alertService.showDialog('Dear Developer!\nIt appears your backend Web API service is not running...\n' +
        'Would you want to temporarily switch to the online Demo API below?(Or specify another)',
        DialogType.prompt,
        (value: string) => {
          this.configurations.baseUrl = value;
          this.alertService.showStickyMessage('API Changed!', 'The target Web API has been changed to: ' + value, MessageSeverity.warn);
        },
        null,
        null,
        null,
        this.configurations.fallbackBaseUrl);
    }
  }



  reset() {
    this.formResetToggle = false;

    setTimeout(() => {
      this.formResetToggle = true;
    });
  }

  ngOnDestroy(): void {
    this.stopFormChangeTracking();
    this.fieldIssueService.clearIssues();
    this.destroy$.next();
    this.destroy$.complete();
    if (this.datatableElement?.dtInstance) {
      this.datatableElement.dtInstance.then((dt) => {
        //dt.clear().destroy(true);
      });
    }

    try {
      $('#Date_of_Incorporation').datepicker('destroy');
    } catch (e) { }

    try {
      $('.select2', this.elRef.nativeElement).select2('destroy');
    } catch (e) { }

    this.modalClosedCallback = null;
  }

  /**
   * Return AccPoRepdata filtered so that reps whose closed date is null OR within last 90 days are included.
   */
  getFilteredAccPoRep(): any[] {
    if (!this.AccPoRepdata || !Array.isArray(this.AccPoRepdata)) {
      return [];
    }

    return this.AccPoRepdata.filter(item => {
      // Use the original (non-formatted) NF record when available so the raw
      // Salesforce closed date is evaluated, not the display-formatted one.
      const original = (this.AccPoRepdataNF || []).find((r: any) => r.icD_Rep_Name === item.icD_Rep_Name) || item;

      // The New ICD Owner dropdown lists the reps promoted BY the selected owner,
      // not the owner themselves. Records whose rep name is empty or equal to the
      // owner's Owner Name / Legal Name belong to the "Existing Owner Opening a New
      // Corp" flow, so exclude them here (that flow is handled by
      // onCheckbox_AccPORepOwnerName).
      const repName = this.normalizeName(original.icD_Rep_Name);
      if (repName === '' || this.isSelectedOwnerName(repName, original.icD_Owner_Name__c)) {
        return false;
      }

      return this.isClosedWithin90Days(original);
    });
  }

  /** Trim, lower-case and collapse inner whitespace so "Raymond  Dube" == "raymond dube". */
  private normalizeName(value: any): string {
    return (value ?? '').toString().trim().replace(/\s+/g, ' ').toLowerCase();
  }

  /**
   * True if an already-normalized rep name is the selected Promoting Owner — matched
   * against the Owner Name, the Account Legal Name, or the record's own ICD Owner Name.
   */
  private isSelectedOwnerName(normalizedRepName: string, recordOwnerName: any): boolean {
    return [this.selected_AccPo, this.selected_AccPoLegalName, recordOwnerName]
      .map(n => this.normalizeName(n))
      .some(n => n !== '' && n === normalizedRepName);
  }

  noHtmlTagsValidator(control: any) {

    if (!control.value) {
      return null;
    }

    const value = control.value.toString();

    // Detect HTML/XML/script-like content
    const htmlPattern =
      /(<[^>]+>|&lt;|&gt;|javascript:|onerror=|onload=|<script|<\/script>)/gi;

    if (htmlPattern.test(value)) {
      return { invalidHtml: true };
    }

    return null;
  }

  getCharacterCount(controlName: string): number {
    return (this.icdForm.get(controlName)?.value || '').length;
  }

  getMaxLength(controlName: string): number {
    return this.fieldMaxLengths[controlName] || 0;
  }

}
